import { render, staticRenderFns } from "./MiniGameLevelEditor.vue?vue&type=template&id=05b6309f&scoped=true"
import script from "./MiniGameLevelEditor.vue?vue&type=script&lang=js"
export * from "./MiniGameLevelEditor.vue?vue&type=script&lang=js"
import style0 from "./MiniGameLevelEditor.vue?vue&type=style&index=0&id=05b6309f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b6309f",
  null
  
)

export default component.exports